var React = require('react');

function Print (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"d":"M5 8V1h12v7M5 17H3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2","key":0}),React.createElement("path",{"d":"M17 13H5v8h12Z","key":1})]));
}

Print.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Print;

Print.default = Print;
